"use strict";

exports.__esModule = true;

var _types = require("@wix/ambassador-membership-api/types");

exports.PlanStatus = _types.V1OrdersSuspensionStatus;
//# sourceMappingURL=exported-types.js.map